module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-mask-3.789484cd.png";